var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingbox",style:(_vm.styleObj),attrs:{"id":_vm.idattr}})
}
var staticRenderFns = []

export { render, staticRenderFns }